// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url:"https://scm.vipstendo.com/AdminService/api/",
  production: false,
  instagram_token: 'IGQVJWbDBib1IyV081a0lfd3IwRTFhS2FGbHZAtbWlXNkpzN3VFMllzaFM4bEtJMHFaSzN1SU1SQl92cU54ekJHbWcxaWx4cUpmNEFkQWtuVXRIZA3JWdGxUUF9tTEktUm9hV2hhRzdzR0JXYkdWam9zbQZDZD',
  stripe_token: 'STRIPE_PUBLISHABLE_KEY',
  paypal_token: 'PAYPAL_CLIENT_ID'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
